import { Row, Col, Card } from "antd";


function HeroSectionRight() {
  return (
    <>
      <Row style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // margin: "15px 0px 15px 0px",
      }}>
        <Col
          xs={24} sm={20} md={10} lg={10} xl={10}
          style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}
        >
          <Card
            style={{
              width: "100%",
              maxWidth: 280,
              backgroundColor: "#fff",
              borderRadius: "10px",
            }}
            bodyStyle={{ padding: "10px" }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  backgroundColor: "transparent",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                  overflow: "hidden",
                }}
              >
                {/* <CheckCircleOutlined style={{ fontSize: 24, color: "rgb(75 85 99)", backgroundColor: "#fff", }} /> */
                }
                <img src={require("../../assets/images/reports.png")} alt="Optix360" />

              </div>
              <div style={{ textAlign: "left" }}>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "18px",
                    color: "#111",
                    fontWeight: 500,
                  }}
                >
                  Reports
                </h2>
                <p style={{ margin: 0, fontSize: "14px", color: "rgb(75 85 99)" }}>
                  All Business Reports
                </p>
              </div>
            </div>
          </Card>
        </Col>
      </Row>

      <Row gutter={[24, 24]} style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        margin: "15px 0px 15px 0px",
      }}>

        <Col
          xs={24} sm={20} md={12} lg={12} xl={12}
          style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}
        >
          <Row
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              width: "100%",
            }}
          >
            <Col span={24} style={{ display: "flex", flexDirection: "column", gap: "16px", alignItems: "center" }}>

              <Card
                style={{
                  width: "100%",
                  maxWidth: 280,
                  backgroundColor: "#fff",
                  borderRadius: "10px",
                }}
                bodyStyle={{ padding: "10px" }}
              >
                <div style={{ display: "flex", alignItems: "center", }}>
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      backgroundColor: "transparent",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={require("../../assets/images/store.jpg")}
                      alt="Optix360"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        // borderRadius: "50%",
                      }}
                    />
                  </div>
                </div>
                <div style={{ textAlign: "left", marginLeft: "10px" }}>
                  <h2
                    style={{
                      margin: 0,
                      fontSize: "18px",
                      color: "#111",
                      fontWeight: 500,
                    }}
                  >
                    Online Store
                  </h2>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "14px",
                      color: "rgb(75 85 99)",
                    }}
                  >
                    Store Management
                  </p>
                </div>
              </Card>
              <Card
                style={{
                  width: "100%",
                  maxWidth: 280,
                  backgroundColor: "#fff",
                  borderRadius: "10px",
                }}
                bodyStyle={{ padding: "10px" }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "transparent",
                      // borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "12px",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={require("../../assets/images/member.png")}
                      alt="Optix360"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        // borderRadius: "50%",
                      }}
                    />
                  </div>
                  <div style={{ textAlign: "left" }}>
                    <h2
                      style={{
                        margin: 0,
                        fontSize: "18px",
                        color: "#111",
                        fontWeight: 500,
                      }}
                    >
                      Customers
                    </h2>
                    <p
                      style={{
                        margin: 0,
                        fontSize: "14px",
                        color: "rgb(75 85 99)",
                      }}
                    >
                      Retailers, Suppliers
                    </p>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </Col>
        <Col
          xs={24} sm={20} md={12} lg={12} xl={12}
          style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}
        >
          <Row
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              width: "100%",
            }}
          >
            <Col span={24} style={{ display: "flex", flexDirection: "column", gap: "16px", alignItems: "center" }}>
              <Card
                style={{
                  width: "100%",
                  maxWidth: 280,
                  backgroundColor: "#fff",
                  borderRadius: "10px",
                }}
                bodyStyle={{ padding: "10px" }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "transparent",
                      // borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "12px",
                      overflow: "hidden",
                    }}
                  >
                    {/* <CheckCircleOutlined style={{ fontSize: 24, color: "rgb(75 85 99)", backgroundColor: "#fff", }} /> */
                    }
                    <img src={require("../../assets/images/tax.png")} alt="Optix360" />

                  </div>
                  <div style={{ textAlign: "left" }}>
                    <h2
                      style={{
                        margin: 0,
                        fontSize: "18px",
                        color: "#111",
                        fontWeight: 500,
                      }}
                    >
                      Inventory Management
                    </h2>
                    <p style={{ margin: 0, fontSize: "14px", color: "rgb(75 85 99)" }}>
                      For Retailers, Suppliers
                    </p>
                  </div>
                </div>
              </Card>
              <Card
                style={{
                  width: "100%",
                  maxWidth: 280,
                  backgroundColor: "#fff",
                  borderRadius: "10px",
                }}
                bodyStyle={{ padding: "10px" }}
              >
                <div style={{ display: "flex", alignItems: "center", }}>
                  <div
                    style={{
                      width: "93%",
                      height: "90%",
                      backgroundColor: "transparent",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={require("../../assets/images/sale-report_11357202.png")}
                      alt="Optix360"
                      style={{
                        width: "93%",
                        height: "90%",
                        objectFit: "cover",
                        // borderRadius: "50%",
                      }}
                    />
                  </div>
                </div>
                <div style={{ textAlign: "left", marginLeft: "10px" }}>
                  <h2
                    style={{
                      margin: 0,
                      fontSize: "18px",
                      color: "#111",
                      fontWeight: 500,
                    }}
                  >
                    Sales
                  </h2>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "14px",
                      color: "rgb(75 85 99)",
                    }}
                  >
                    Manage Sales
                  </p>
                </div>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row gutter={[24, 24]} style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "15px 0px 15px 0px",
      }}>
        <Col
          xs={24} sm={20} md={12} lg={12} xl={12}
          style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}
        >
          <Card
            style={{
              width: "100%",
              maxWidth: 280,
              backgroundColor: "#fff",
              borderRadius: "10px",
            }}
            bodyStyle={{ padding: "10px" }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  backgroundColor: "transparent",
                  // borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                  overflow: "hidden",
                }}
              >
                <img
                  src={require("../../assets/images/pos.png")}
                  alt="Optix360"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    // borderRadius: "50%",
                  }}
                />
              </div>
              <div style={{ textAlign: "left" }}>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "18px",
                    color: "#111",
                    fontWeight: 500,
                  }}
                >

                  POS


                </h2>
                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    color: "rgb(75 85 99)",
                  }}
                >
                  Simple But Effective POS
                </p>
              </div>
            </div>
          </Card>
        </Col>

        <Col
          xs={24} sm={20} md={12} lg={12} xl={12}
          style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}
        >
          {/* <Card
            style={{
              width: 280,
              backgroundColor: "#fff",
              borderRadius: "10px",
            }}
            bodyStyle={{ padding: "10px" }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  backgroundColor: "transparent",
                  // borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                  overflow: "hidden",
                }}
              >

                <img src={require("../../assets/images/salesmanage.png")} alt="Optix360" />

              </div>
              <div style={{ textAlign: "left" }}>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "18px",
                    color: "#111",
                    fontWeight: 500,
                  }}
                >
                  Sales
                </h2>
                <p style={{ margin: 0, fontSize: "14px", color: "rgb(75 85 99)" }}>
                  Manage Sales
                </p>
              </div>
            </div>
          </Card> */}
          <Card
            style={{
              width: "100%",
              maxWidth: 280,
              backgroundColor: "#fff",
              borderRadius: "10px",
            }}
            bodyStyle={{ padding: "10px" }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  backgroundColor: "transparent",
                  // borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                  overflow: "hidden",
                }}
              >
                {/* <CheckCircleOutlined style={{ fontSize: 24, color: "rgb(75 85 99)", backgroundColor: "#fff", }} /> */
                }
                <img src={require("../../assets/images/multistores.png")} alt="Optix360" />

              </div>
              <div style={{ textAlign: "left" }}>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "18px",
                    color: "#111",
                    fontWeight: 500,
                  }}
                >
                  Wholesaler/Retailer


                </h2>
                <p style={{ margin: 0, fontSize: "14px", color: "rgb(75 85 99)" }}>
                  Manage Multiple Stores
                </p>
              </div>
            </div>
          </Card>
        </Col>
      </Row>

      <Row gutter={[24, 24]} style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "15px 0px 15px 0px",
      }}>
        <Col
          xs={24} sm={20} md={12} lg={12} xl={12}
          style={{ display: "flex", justifyContent: "center" }}
        >

        </Col>

        <Col
          xs={24} sm={20} md={12} lg={12} xl={12}
          style={{ display: "flex", justifyContent: "center" }}
        >

        </Col>
      </Row>
    </>
  )
}

export default HeroSectionRight;